import React, { FC, useEffect, useMemo, useState } from 'react';

import { alpha } from '@mui/material/styles';
import cn from 'classnames';
import { useMenu } from 'react-instantsearch';

import AnimatedSkeleton from '../../../../components/AnimatedSkeleton';
import styled from '../../../../styled';
import { SMALL_MARGIN, SMALL_MARGIN_PX } from '../../../../theme';
import { lettersArray } from './const';

interface IndexMenuProps {
  attribute: string;
  limit?: number;
  loading?: boolean;
}

const IndexMenu: FC<IndexMenuProps> = ({ attribute, limit, loading = false }) => {
  const { items, refine } = useMenu({ attribute, limit });

  const [hasRefined, setHasRefined] = useState(false);
  const normalizedItems = useMemo(() => {
    const obj = {};
    items.forEach((item) => {
      obj[item.label] = item;
    });

    return obj;
  }, [items]);

  useEffect(() => {
    setHasRefined(!!items.filter((item) => item.isRefined).length);
  }, [items]);

  return loading ? (
    <LoadingCard xs="150px" />
  ) : (
    <Wrapper>
      <Index key="all" className={!hasRefined && 'active'} onClick={() => refine('')}>
        All
      </Index>
      {lettersArray.map((item) => {
        const exists = item in normalizedItems;
        return (
          <Index
            key={item}
            className={cn(exists ? normalizedItems[item].isRefined && 'active' : 'disabled')}
            onClick={exists ? () => refine(normalizedItems[item].value) : () => {}}
          >
            {item}
          </Index>
        );
      })}
    </Wrapper>
  );
};

export default IndexMenu;

const LoadingCard = styled(AnimatedSkeleton)`
  width: 100%;
`;

const Wrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -${SMALL_MARGIN_PX};
  margin-right: -${SMALL_MARGIN_PX};
  width: calc(100% + ${SMALL_MARGIN_PX});

  ${({ theme }) => theme.breakpoints.up('xl')} {
    width: 318px;
  }
`;
const Index = styled('div')`
  color: ${({ theme }) => theme.palette.common.white};
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  margin-right: ${SMALL_MARGIN_PX};
  margin-bottom: ${SMALL_MARGIN_PX};
  width: 27px;

  &.active {
    color: ${({ theme }) => theme.palette.common.blue};
  }

  &.disabled {
    color: ${({ theme }) => alpha(theme.palette.common.white, 0.33)};
    cursor: default;
  }

  ${({ theme }) => theme.breakpoints.up('xl')} {
    width: calc((100% - ${SMALL_MARGIN * 7}px) / 7);
  }
`;
